// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScopeSchema } from '../inputTypeSchemas/ScopeSchema'
import { DnsSourceTypeSchema } from '../inputTypeSchemas/DnsSourceTypeSchema'

/////////////////////////////////////////
// DOMAIN SCHEMA
/////////////////////////////////////////

/**
 * DNS name relevant to the target. Roots back to ExternalNetwork; can self-reference via parentId.
 */
export const DomainSchema = z.object({
  scope: ScopeSchema,
  sourceType: DnsSourceTypeSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  fqdn: z.string(),
  isTopLevel: z.boolean(),
  parentId: z.string().nullable(),
  registrar: z.string().nullable(),
  classification: z.string().nullable(),
  classificationConfidence: z.number().int().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Domain = z.infer<typeof DomainSchema>

export default DomainSchema;
